function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoadMoreWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 74 74",
  style: {
    enableBackground: "new 0 0 74 74"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#fff"
  },
  className: "load_more_white_svg__st0",
  d: "M38.5 22h-2v14.5H22v2h14.5V53h2V38.5H53v-2H38.5z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#fff"
  },
  d: "M37 0C16.6 0 0 16.6 0 37s16.6 37 37 37 37-16.6 37-37S57.4 0 37 0zm13.6 69.2C46.3 71.1 41.7 72 37 72 17.7 72 2 56.3 2 37S17.7 2 37 2s35 15.7 35 35c0 14.1-8.4 26.8-21.4 32.2z"
}));
export default SvgLoadMoreWhite;